module.exports = __webpack_public_path__ + "static/media/Privacy_Policy_FSA.bc502ab2.pdf";